export default {
    state: {
        currentRoute: {},
        isCollapse: false
    },
    mutations: {
        SET_ROUTE(state, route) {
            state.currentRoute = route;
        },
        SET_COLLAPSE(state, res) {
            state.isCollapse = res;
        }
    },
    actions: {},
    getters: {
        currentRoute: state => state.currentRoute,
        isCollapse: state => state.isCollapse
    }
}